<template>
  <div>
    <div
      class="modal fade"
      id="modalBloqueado"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalBloqueadoTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalBloqueadoTitle">
              Veículo Devolvido e Bloqueado
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="dataModal.photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="titlePR">Dados da Reserva:</div>
                  <div class="car-desc">
                    <div class="text">
                      {{ dataModal.description }} {{ dataModal.color }}
                    </div>
                    <div class="data">{{ dataModal.board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Número da Reserva:</div>
                    <div class="data">
                      #{{ dataModal.reserve_vehicle[0].id }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Reservado Para:</div>
                    <div class="data">
                      {{ dataModal.reserve_vehicle[0].user.name }}
                      <button
                        class="btn btn-user"
                        data-tooltip="tooltip"
                        title="Dados do Usuário"
                        data-dismiss="modal"
                        data-toggle="modal"
                        @click="openModalUser(dataModal.reserve_vehicle[0])"
                      >
                        <i class="fas fa-user"></i>
                      </button>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirada Estimada:</div>
                    <div class="data">
                      {{ dataModal.reserve_vehicle[0].retreat_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Retirado Em:</div>
                    <div class="data">
                      {{ dataModal.reserve_vehicle[0].checkout.retreat_at }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolução Estimada:</div>
                    <div class="data">
                      {{ dataModal.reserve_vehicle[0].devolution_date }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Devolvido em:</div>
                    <div class="data">
                      {{ dataModal.reserve_vehicle[0].checkin.devoluted_at }}
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="dataModal.current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="buttons">
                    <a
                      href="#"
                      class="btn btn-add float-right"
                      data-dismiss="modal"
                      @click="openModal(dataModal.reserve_vehicle[0])"
                      >Visualizar Checklist</a
                    >
                    <a
                      href="#"
                      @click="unlock(dataModal.id, dataModal.board)"
                      data-dismiss="modal"
                      class="btn btn-alt float-left"
                      >Desbloquear Veículo</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="last-trips">
              <div class="title">Últimas viagens deste veículo:</div>
              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Condutor</th>
                      <th scope="col">Retirado em</th>
                      <th scope="col">Entregue em</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>
                  <tbody v-if="dataModal.last_trips.length > 0">
                    <tr
                      v-for="lastTrip in dataModal.last_trips"
                      :key="lastTrip.id"
                    >
                      <td v-if="lastTrip && lastTrip.user">
                        {{ lastTrip.user.name }}
                      </td>
                      <td v-if="lastTrip && lastTrip.checkout">
                        {{
                          lastTrip.checkout ? lastTrip.checkout.retreat_at : ""
                        }}
                      </td>
                      <td v-if="lastTrip && lastTrip.checkin">
                        {{
                          lastTrip.checkin ? lastTrip.checkin.devoluted_at : ""
                        }}
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-crud check"
                          @click="openModal(lastTrip)"
                          data-tooltip="tooltip"
                          data-dismiss="modal"
                          data-toggle="modal"
                          data-target="#modalLastTrips"
                          title="Consultar informações"
                        >
                          <i class="fas fa-sign-out-alt"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <pagination
                          style="margin-top: 25px"
                          :records="dataModal.lastTrips.total"
                          :options="options"
                          :per-page="5"
                          @paginate="paginate"
                        ></pagination>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" align="center">
                        Este veículo ainda não realizou viagens.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "vue-pagination-2";
export default {
  components: { Pagination },
  props: ["modalStatus", "dataModal"],

  data() {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        page: 1,
        chunk: 4,
        chunksNavigation: "fixed",
      },
    };
  },
  watch: {
    modalStatus: function (newStatus) {
      if (newStatus == true) {
        this.startModal();
      }
    },
  },
  computed: {},
  mounted() {
    if (this.modalStatus == true) {
      this.startModal();
    }
  },
  methods: {
    paginate(page) {
      const self = this;
      self.$emit(
        "openModals",
        self.dataModal.id,
        self.dataModal.status,
        self.dataModal,
        page
      );
    },
    unlock(id, board) {
      const self = this;
      self.unlockFunction(id, board);
    },
    unlockFunction(id, board) {
      const self = this;

      let api = self.$store.state.api + "vehicles/" + id;
      let fd = new FormData();

      fd.append("_method", "PATCH");

      fd.append("board", board);
      fd.append("vehicle_status_id", 1);

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Veículo Desbloqueado`, "success");
          this.$emit("refresh", false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    openModal(object) {
      this.$emit("OMDCk", object);
    },
    openModalUser(object) {
      this.$emit("OpenModalUser", object);
    },
    startModal() {
      this.clean();
      $("#modalBloqueado").modal("toggle");
    },
    clean() {
      this.$emit("changeModal", false);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modals/DevolutedModal.vue